import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isHintVisible)?_c(VContainer,{staticClass:"app-impersonation-hint pb-0",attrs:{"data-cy":"impersonation-hint"}},[_c('a-danger-alert',[_c('font-awesome-icon',{staticClass:"ml-1 ml-sm-2 mr-4",attrs:{"icon":['fas', 'exclamation-triangle']}}),_c('span',{domProps:{"innerHTML":_vm._s(_vm.alertHTML)}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }